
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindTrue11 as ObiWindTrue11Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-true-11.js';
 
 
 

 
 export const ObiWindTrue11 = createComponent({
   react: React,
   tagName: 'obi-wind-true-11',
   elementClass: ObiWindTrue11Element,
   events: {
     
   }
  });
 
 